import React, { useEffect, useState } from "react";
import { cget, gbp, inputCls } from "./api";

const COLS = [["subscribers", "Customers", false], ["gross", "Gross"], ["refunds", "Refunds"], ["tax", "VAT / tax"], ["net", "Net"],
  ["affiliate", "Affiliate"], ["partner", "Partner"], ["principals", "Network Principals"], ["processing", "Processing"],
  ["ai", "AI"], ["voice", "Voice"], ["other_costs", "Other costs"], ["contribution", "Soulumo contribution"]];

export const ProfitTab = ({ ym }) => {
  const [by, setBy] = useState("business");
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); cget("/profitability", { by, ym }).then(setD).catch(() => setD({ rows: [] })); }, [by, ym]);
  return (
    <div data-testid="commissions-profit-tab">
      <div className="flex flex-wrap gap-2">
        {["business", "network", "partner", "affiliate", "customer", "product"].map((b) => (
          <button key={b} type="button" onClick={() => setBy(b)} data-testid={`profit-by-${b}`}
            className={`rounded-full px-3 py-1 text-xs capitalize transition-colors ${by === b ? "bg-[#2b2b2b] text-white" : "border border-[#e5e0d3] bg-white"}`}>{b}</button>
        ))}
      </div>
      <div className="mt-4 overflow-x-auto">
        <table className="w-full min-w-[1100px] text-right text-xs">
          <thead className="uppercase tracking-wider text-[#6b6b6b]"><tr><th className="py-2 text-left">{by}</th>{COLS.map(([k, l]) => <th key={k} className="px-1.5">{l}</th>)}</tr></thead>
          <tbody>
            {(d?.rows || []).map((r) => (
              <tr key={r.key} className="border-t border-[#eee9dc]" data-testid={`profit-row-${r.key}`}>
                <td className="py-2 text-left">{r.name}</td>
                {COLS.map(([k, , money = true]) => <td key={k} className={`px-1.5 tabular-nums ${k === "contribution" ? (r[k] < 0 ? "text-[#a0522d]" : "font-medium text-[#4A6741]") : ""}`}>{money ? gbp(r[k]) : r[k] || 0}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
        {d && !d.rows.length && <p className="mt-3 text-sm text-[#8a8a8a]" data-testid="profit-empty">No payments recorded for this period yet.</p>}
      </div>
      <p className="mt-3 text-xs text-[#8a8a8a]">From the payment ledger. VAT is the amount Stripe charged (or the fallback rate where Stripe gave none). Costs use your Settings assumptions.</p>
    </div>
  );
};

export const MonthPicker = ({ ym, setYm }) => (
  <label className="text-sm">Month <input type="month" value={ym} onChange={(e) => setYm(e.target.value)} className={inputCls} data-testid="commissions-month" /></label>
);
